module.exports = __webpack_public_path__ + "static/img/idies-logo-big3.3c1dd44.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/idies-logo-big3.png
// module id = tYzz
// module chunks = 1